import { JSX } from 'react';
// Imports dos ícones que usam o sufixo 'Icon' ou são componentes diretamente exportados
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import SouthAmericaIcon from '@mui/icons-material/SouthAmerica';
import VillaIcon from '@mui/icons-material/Villa';
import PeopleIcon from '@mui/icons-material/People';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GroupsIcon from '@mui/icons-material/Groups';
import CategoryIcon from '@mui/icons-material/Category';
import ScaleIcon from '@mui/icons-material/Scale';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import BuildIcon from '@mui/icons-material/Build';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BarChartIcon from '@mui/icons-material/BarChart';
import SchoolIcon from '@mui/icons-material/School';
import BadgeIcon from '@mui/icons-material/Badge';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ChecklistIcon from '@mui/icons-material/Checklist';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import Inventory from '@mui/icons-material/Inventory';


// Imports dos ícones que são componentes de nome único
import {
  Autorenew,
  Handshake,
  SwapHoriz,
  AccountTree,
  Description,
  CreditCard,
  AccountBalance,
  Cake,
  ConfirmationNumber,
  Engineering,
  SwapHorizSharp,
  LocalShipping,
  Settings,
  Storefront,
  BrandingWatermark,
  LocationCity,
  EventBusy,
  EventAvailable,
  Percent,
  VerifiedUser,
  WhatsApp,
  Message,
} from '@mui/icons-material';


const iconMap: Record<string, JSX.Element> = {
  // Cadastros Base
  AddBusiness: <AddBusinessIcon />,
  SouthAmerica: <SouthAmericaIcon />,
  Villa: <VillaIcon />,
  People: <PeopleIcon />,
  ManageAccounts: <ManageAccountsIcon />,
  Groups: <GroupsIcon />,
  Category: <CategoryIcon />,
  Scale: <ScaleIcon />,
  AttachMoney: <AttachMoneyIcon />,
  Build: <BuildIcon />, // Serviços
  ConfirmationNumber: <ConfirmationNumber />,
  Engineering: <Engineering />,

  // Compra e Venda
  PointOfSale: <PointOfSaleIcon />, // Vendas
  ShoppingBasket: <ShoppingBasketIcon />, // Compras

  // Financeiro e Configurações
  AccountBalanceWallet: <AccountBalanceWalletIcon />, // Financeiro
  Autorenew: <Autorenew />, // Financeiro Recorrente
  SwapHoriz: <SwapHoriz />, // Tipos de Operação
  Handshake: <Handshake />, // Tipos de Negociação
  AccountTree: <AccountTree />, // Centros de Custo
  Description: <Description />, // Tipos de Título
  CreditCard: <CreditCard />, // Carnês
  AccountBalance: <AccountBalance />, // Bancos
  AccountBox: <AccountBoxIcon />, // Contas Bancárias

  // Educacional/Academia
  School: <SchoolIcon />, // Turmas
  Badge: <BadgeIcon />, // Alunos
  Schedule: <ScheduleIcon />, // Aulas por Turma
  Checklist: <ChecklistIcon />, // Controle de Frequência
  Person: <PeopleIcon />,

  // Relatórios
  BarChart: <BarChartIcon />,
  Cake: <Cake />, // Aniversariantes

  //Estoque

  Inventory: <Inventory />,
  BrandingWatermark : <BrandingWatermark/>,

  //Cte
  LocalShipping: <LocalShipping />,
  Percent: <Percent />,

  //Pdv
  Settings: <Settings />,
  Storefront: <Storefront />,

  //Agenda
  LocationCity : <LocationCity />,
  EventBusy : <EventBusy />,
  EventAvailable : <EventAvailable />,

  //fiscal
  VerifiedUser: <VerifiedUser />,
  WhatsApp: <WhatsApp />,
  Message: <Message />
  

};

export default iconMap;